import http from 'hub-http/clients/apiClient';
const FETCH_GOAL_NAMES_FOR_REPORT_URL = '/performance/v1/goals/search/goal-names-srv';
const FETCH_DISAGGREGATED_GOAL_NAMES_FOR_REPORT_URL = '/performance/v1/goals/search/goal-names-disaggregated-srv';
export const fetchGoalsForReport = data => http.post(FETCH_GOAL_NAMES_FOR_REPORT_URL, {
  data
});
export const fetchDisaggregatedGoalsForReport = data => http.post(FETCH_DISAGGREGATED_GOAL_NAMES_FOR_REPORT_URL, {
  data
});